import React from "react";

import { getPreviewFramePrintFontSize } from "@/utils/qrEditorHelper";

import { QRFRameToPrintProps } from "../types";

import { uriText } from "./uri";

import "../styles.scss";

export const ChristmasFrameToDownload = (
  props: QRFRameToPrintProps
): React.SVGProps<SVGSVGElement> => {
  const {
    text,
    textColor,
    frameColor,
    frameBackgroundColor,
    height = 1200,
    qrSvg,
    width = 900,
  } = props;

  const fontSize = getPreviewFramePrintFontSize(text?.length);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none">
      <style>
        {`
              @font-face {
                font-family: 'Nunito Sans';
                src: url(${uriText});
                font-weight: bold
              }
            `}
      </style>
      <g id="surface1">
        <path
          fillRule="nonzero"
          fill="white"
          fillOpacity="1"
          strokeWidth="1"
          stroke="#BFBFBF"
          d="M 7.999875 0.5 L 88.000125 0.5 C 92.142 0.5 95.500125 3.857839 95.500125 8 L 95.500125 120 C 95.500125 124.142161 92.142 127.5 88.000125 127.5 L 7.999875 127.5 C 3.858 127.5 0.499875 124.142161 0.499875 120 L 0.499875 8 C 0.499875 3.857839 3.858 0.5 7.999875 0.5 Z M 7.999875 0.5 "
          transform="matrix(10.416667,0,0,10.414062,0,0)"
        />

        <path
          stroke="none"
          fillRule="nonzero"
          fill={frameColor}
          d="M 662.886719 520.703125 L 669.621094 487.972656 C 670.144531 485.441406 669.460938 482.816406 667.789062 480.832031 C 666.097656 478.835938 663.59375 477.679688 660.9375 477.679688 L 649.222656 477.679688 L 633.734375 440.058594 C 632.386719 436.800781 629.140625 434.65625 625.515625 434.65625 L 617.980469 434.65625 C 661.476562 402.347656 687.5 352.078125 687.5 297.535156 C 687.5 248.410156 665.910156 201.472656 628.273438 168.75 C 590.269531 135.707031 541.292969 120.546875 490.140625 126.089844 C 409.507812 134.832031 344.097656 198.132812 334.609375 276.605469 C 327.914062 331.960938 347.816406 385.4375 389.207031 423.328125 L 401.34375 410.796875 C 364.066406 376.691406 346.15625 328.503906 352.183594 278.609375 C 360.738281 208.011719 419.574219 151.054688 492.113281 143.183594 C 538.050781 138.21875 582.261719 151.824219 616.46875 181.558594 C 650.355469 211.03125 669.792969 253.296875 669.792969 297.535156 C 669.792969 355.203125 637.503906 407.554688 585.367188 434.65625 L 536.96875 434.65625 L 536.96875 400.238281 L 590.101562 400.238281 C 593.003906 400.238281 595.71875 398.855469 597.378906 396.542969 C 599.03125 394.214844 599.40625 391.257812 598.386719 388.613281 L 576.3125 331.402344 L 581.246094 331.402344 C 584.148438 331.402344 586.867188 330.015625 588.523438 327.703125 C 590.179688 325.378906 590.550781 322.417969 589.53125 319.777344 L 567.457031 262.566406 L 572.390625 262.566406 C 575.867188 262.566406 579.011719 260.59375 580.445312 257.515625 C 581.890625 254.441406 581.339844 250.835938 579.058594 248.289062 L 517.074219 179.457031 C 513.703125 175.71875 507.113281 175.71875 503.742188 179.457031 L 441.757812 248.289062 C 439.476562 250.828125 438.921875 254.441406 440.363281 257.515625 C 441.800781 260.59375 444.945312 262.566406 448.425781 262.566406 L 453.359375 262.566406 L 431.28125 319.777344 C 430.265625 322.417969 430.648438 325.378906 432.292969 327.703125 C 433.949219 330.015625 436.667969 331.402344 439.570312 331.402344 L 444.5 331.402344 L 422.425781 388.613281 C 421.410156 391.257812 421.789062 394.214844 423.4375 396.542969 C 425.089844 398.855469 427.8125 400.238281 430.714844 400.238281 L 483.84375 400.238281 L 483.84375 434.65625 L 395.296875 434.65625 C 391.675781 434.65625 388.425781 436.800781 387.070312 440.058594 L 371.59375 477.679688 L 359.878906 477.679688 C 357.222656 477.679688 354.714844 478.835938 353.035156 480.832031 C 351.359375 482.816406 350.675781 485.441406 351.203125 487.972656 L 357.929688 520.703125 Z M 465.578125 325.816406 C 466.59375 323.175781 466.214844 320.214844 464.566406 317.894531 C 462.902344 315.578125 460.183594 314.191406 457.277344 314.191406 L 452.347656 314.191406 L 474.421875 256.980469 C 475.441406 254.335938 475.0625 251.378906 473.410156 249.058594 C 472.082031 247.191406 470.046875 245.921875 467.800781 245.511719 L 510.40625 198.191406 L 553.015625 245.519531 C 550.769531 245.933594 548.738281 247.199219 547.398438 249.066406 C 545.746094 251.386719 545.375 254.347656 546.394531 256.988281 L 568.46875 314.191406 L 563.539062 314.191406 C 560.628906 314.191406 557.914062 315.578125 556.253906 317.894531 C 554.601562 320.214844 554.226562 323.175781 555.246094 325.816406 L 577.320312 383.027344 L 443.492188 383.027344 Z M 501.554688 400.238281 L 519.261719 400.238281 L 519.261719 434.65625 L 501.554688 434.65625 Z M 401.292969 451.867188 L 619.523438 451.867188 L 630.148438 477.679688 L 390.664062 477.679688 Z M 401.292969 451.867188 "
        />
        <path
          stroke="none"
          fillRule="nonzero"
          fill={frameColor}
          d="M 536.980469 326.355469 C 534.542969 322.238281 529.148438 320.851562 524.695312 322.820312 C 512.125 328.367188 498.285156 331.289062 484.59375 331.386719 C 479.699219 331.425781 475.414062 334.890625 474.992188 339.625 C 474.570312 344.363281 478.175781 348.5625 483.070312 348.605469 C 483.433594 348.609375 483.792969 348.609375 484.152344 348.609375 C 501.285156 348.609375 518.1875 344.902344 533.546875 337.808594 C 537.964844 335.769531 539.414062 330.476562 536.980469 326.355469 Z M 536.980469 326.355469 "
        />
        <path
          stroke="none"
          fillRule="nonzero"
          fill={frameColor}
          d="M 528.597656 274.28125 C 532.117188 270.976562 531.765625 265.511719 528.113281 262.351562 C 524.460938 259.199219 518.894531 259.542969 515.328125 262.800781 C 505.496094 271.773438 493.9375 278.621094 481.277344 282.96875 C 476.667969 284.550781 473.785156 289.195312 474.988281 293.796875 C 476.1875 298.402344 481.023438 301.222656 485.65625 299.699219 C 501.734375 294.421875 516.34375 285.773438 528.597656 274.28125 Z M 528.597656 274.28125 "
        />
        <path
          stroke="none"
          fillRule="nonzero"
          fill={frameColor}
          d="M 634.371094 245.355469 C 634.371094 250.105469 630.40625 253.960938 625.515625 253.960938 C 620.625 253.960938 616.664062 250.105469 616.664062 245.355469 C 616.664062 240.605469 620.625 236.75 625.515625 236.75 C 630.40625 236.75 634.371094 240.605469 634.371094 245.355469 Z M 634.371094 245.355469 "
        />
        <path
          stroke="none"
          fillRule="nonzero"
          fill={frameColor}
          d="M 386.441406 245.355469 C 386.441406 250.105469 390.40625 253.960938 395.296875 253.960938 C 400.1875 253.960938 404.148438 250.105469 404.148438 245.355469 C 404.148438 240.605469 400.1875 236.75 395.296875 236.75 C 390.40625 236.75 386.441406 240.605469 386.441406 245.355469 Z M 386.441406 245.355469 "
        />
        <path
          stroke="none"
          fillRule="nonzero"
          fill={frameColor}
          d="M 652.082031 296.984375 C 652.082031 301.734375 648.117188 305.585938 643.230469 305.585938 C 638.335938 305.585938 634.371094 301.734375 634.371094 296.984375 C 634.371094 292.230469 638.335938 288.378906 643.230469 288.378906 C 648.117188 288.378906 652.082031 292.230469 652.082031 296.984375 Z M 652.082031 296.984375 "
        />
        <path
          stroke="none"
          fillRule="nonzero"
          fill={frameColor}
          d="M 368.734375 296.984375 C 368.734375 301.734375 372.695312 305.585938 377.585938 305.585938 C 382.476562 305.585938 386.441406 301.734375 386.441406 296.984375 C 386.441406 292.230469 382.476562 288.378906 377.585938 288.378906 C 372.695312 288.378906 368.734375 292.230469 368.734375 296.984375 Z M 368.734375 296.984375 "
        />
        <path
          stroke="none"
          fillRule="nonzero"
          fill={frameColor}
          d="M 625.515625 348.609375 C 625.515625 353.363281 621.554688 357.214844 616.664062 357.214844 C 611.769531 357.214844 607.808594 353.363281 607.808594 348.609375 C 607.808594 343.859375 611.769531 340.007812 616.664062 340.007812 C 621.554688 340.007812 625.515625 343.859375 625.515625 348.609375 Z M 625.515625 348.609375 "
        />
        <path
          stroke="none"
          fillRule="nonzero"
          fill={frameColor}
          d="M 395.296875 348.609375 C 395.296875 353.363281 399.261719 357.214844 404.148438 357.214844 C 409.039062 357.214844 413.007812 353.363281 413.007812 348.609375 C 413.007812 343.859375 409.039062 340.007812 404.148438 340.007812 C 399.261719 340.007812 395.296875 343.859375 395.296875 348.609375 Z M 395.296875 348.609375 "
        />
        <path
          stroke="none"
          fillRule="nonzero"
          fill={frameColor}
          d="M 598.953125 202.332031 C 598.953125 207.082031 594.992188 210.9375 590.101562 210.9375 C 585.207031 210.9375 581.246094 207.082031 581.246094 202.332031 C 581.246094 197.582031 585.207031 193.726562 590.101562 193.726562 C 594.992188 193.726562 598.953125 197.582031 598.953125 202.332031 Z M 598.953125 202.332031 "
        />
        <path
          stroke="none"
          fillRule="nonzero"
          fill={frameColor}
          d="M 421.863281 202.332031 C 421.863281 207.082031 425.824219 210.9375 430.714844 210.9375 C 435.609375 210.9375 439.570312 207.082031 439.570312 202.332031 C 439.570312 197.582031 435.609375 193.726562 430.714844 193.726562 C 425.824219 193.726562 421.863281 197.582031 421.863281 202.332031 Z M 421.863281 202.332031 "
        />

        <path
          stroke="none"
          fillRule="nonzero"
          fill={frameBackgroundColor}
          d="M 260.417969 520.703125 L 739.582031 520.703125 C 751.089844 520.703125 760.417969 530.027344 760.417969 541.53125 L 760.417969 1020.578125 C 760.417969 1032.082031 751.089844 1041.40625 739.582031 1041.40625 L 260.417969 1041.40625 C 248.910156 1041.40625 239.582031 1032.082031 239.582031 1020.578125 L 239.582031 541.53125 C 239.582031 530.027344 248.910156 520.703125 260.417969 520.703125 Z M 260.417969 520.703125 "
        />

        <g
          stroke="null"
          transform="matrix(6.2212 0 0 6.2212 0 -55)"
          id="svg_485">
          <g
            dangerouslySetInnerHTML={{ __html: qrSvg }}
            stroke="null"
            id="svg_486"></g>
        </g>
        <text
          x="500"
          y="1150.3999700784689"
          dominantBaseline="middle"
          textAnchor="middle"
          fill={textColor}
          fontFamily="Nunito Sans"
          style={{ fontSize }}>
          {text}
        </text>
      </g>
    </svg>
  );
};
